import { startWebComponentLoader } from "./webComponentLoader";

startWebComponentLoader();
